import { Divider, Grid } from "@mui/material";
import MxCPropertyContent from "./property-elements-card/MxCPropertyContent";
import MxCPropertyPicture from "./property-elements-card/MxCPropertyPicture";
import MxCPropertyContentDetail from "./property-elements-card/MxCPropertyContentDetailLarge";
import MxCPropertyTitle from "./property-elements-card/MxCPropertyTitle";
import { ICardProperty } from "../../../../model/card-property.model";
import MxCPropertyPrice from "./property-elements-card/MxCPropertyPrice";
import MxCPropertyFeature from "./property-elements-card/MxCPropertyImprovements";
import MxCPropertyContentHeader from "./property-elements-card/MxCPropertyContentHeader";
import MxCPropertyRainbowLabel from "./property-elements-card/MxCPropertyRainbowLabel";
import toast from "react-hot-toast";
import MxTypography from "@rf-l1/MxTypography";
import MxCPropertyStatus from "./property-elements-card/MxCPropertyStatus";
import MxCPropertyStans from "./property-elements-card/MxCPropertyStans";
import MxMenu, { MxMenuItemProps } from "@rf-l1/MxMenu";
import MxIcons from "@rf-l1/MxIcons";
import { IconDotsVertical } from "@tabler/icons-react";
import { EFontFamilies } from "@/shared/theme/theme";
import MxCPropertyLocation from "./property-elements-card/MxCPropertyLocation";
import MxCPropertyCheck from "./property-elements-card/MxCPropertyCheck";
import MxCPropertyRemaxGlobalSync from "./property-elements-card/MxCPropertyRemaxGlobalSync";
import { useMemo } from "react";
import { getConditionStatusLabel } from "@/src-refactor/modules/shared/components/refactor/helpers/property/prepare-condition-status-label";
import { C_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";

export interface MxCardPropertySmall extends ICardProperty {
  itemsMenu?: MxMenuItemProps[];
  topLeftComponent?: React.ReactNode;
  onClick?: () => void;
}

const MxCardPropertySmall = (props: MxCardPropertySmall) => {
  const conditionLabel = useMemo(() => {
    return getConditionStatusLabel(props.conditionStatus, props.businessType);
  }, [props.conditionStatus, props.businessType]);

  const conditionColor =
    conditionLabel === C_CONDICTION_PROPERTY.NEW.name ? "#8CC63F" : "red";

  const handleCopyOnClick = async (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(props.id.toString());
      toast.success("Copiado al portapapeles");
    } catch (error) {
      toast.error("Error al copiar");
    }
  };

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <MxCPropertyContent
      pb={0.5}
      className={`card-property `}
      // key={props.id}
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        margin: "0 auto"
      }}
    >
      <MxCPropertyContentHeader>
        {Boolean(props.pictures) && <MxCPropertyPicture pictures={props.pictures} />}
        {Boolean(props.topLeftComponent) && (
          <MxCPropertyCheck
            children={props.topLeftComponent}
            variant="top-left"
            onClick={e => {
              e.stopPropagation();
            }}
          />
        )}

        {Boolean(conditionLabel) && (
          <MxCPropertyRainbowLabel
            children={conditionLabel}
            background={conditionColor}
            variant="top-right"
          />
        )}

        {Boolean(props.isCollection) && (
          <MxCPropertyRainbowLabel
            children="Collection"
            background="red"
            variant="bottom-left"
          />
        )}

        {Boolean(props.id) && (
          <MxCPropertyRainbowLabel
            children={`ID: ${props.id}`}
            variant="bottom-right"
            onClick={handleCopyOnClick}
          />
        )}
      </MxCPropertyContentHeader>

      <MxCPropertyContentDetail container rowGap={1} minHeight={190}>
        {Boolean(props?.title) && (
          <Grid item xs={11}>
            <MxCPropertyTitle children={props.title} />
          </Grid>
        )}

        {Boolean(props.itemsMenu) && (
          <Grid
            item
            xs={1}
            container
            justifyContent="flex-end"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <MxMenu items={props.itemsMenu || []} width={"auto"}>
              <MxIcons size={16} color="primary.main">
                <IconDotsVertical />
              </MxIcons>
            </MxMenu>
          </Grid>
        )}

        {Boolean(props?.nameProperty) && (
          <Grid item xs={12}>
            <MxTypography
              variant="overline"
              color="grey.600"
              fontWeight={600}
              lines={1}
              children={props?.nameProperty}
            />
          </Grid>
        )}

        {Boolean(props?.prices?.length) && (
          <Grid container my={0.8} rowGap={0.5}>
            {props?.prices?.map((price, i) => (
              <Grid item xs={12} key={i}>
                <MxCPropertyPrice {...price} />
              </Grid>
            ))}
          </Grid>
        )}

        {Boolean(props?.location) && (
          <Grid item xs={12}>
            <MxCPropertyLocation location={props.location ?? ""} />
          </Grid>
        )}

        {/* {Boolean(props?.syncStatus) && (
          <Grid item xs={12} my={0.2}>
            <MxCPropertyRemaxGlobalSync syncStatus={props.syncStatus} />
          </Grid>
        )} */}

        {props?.agents && (
          <Grid
            item
            xs="auto"
            my={0.5}
            container
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              backgroundColor: "#bfd7ff",
              borderRadius: 1,
              p: 0.7,
              "& > *": {
                fontSize: "10px !important"
              }
            }}
          >
            <MxTypography
              fontFamily={EFontFamilies.DEFAULT_FONT}
              variant="overline"
              color="primary.main"
              fontWeight={600}
            >
              AGENTE(S):
            </MxTypography>
            <MxTypography
              fontFamily={EFontFamilies.SECONDARY_FONT}
              variant="overline"
              color="primary.main"
              fontWeight={400}
              lines={1}
              maxWidth={150}
            >
              {props.agents}
            </MxTypography>
          </Grid>
        )}
      </MxCPropertyContentDetail>

      <Grid
        container
        gap={1}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        {Boolean(Object.values(props?.feature ?? {}).filter(x => x).length) && (
          <Grid item xs={12} container rowGap={0.5}>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12} px={2}>
              {props.feature && (
                <MxCPropertyFeature
                  bathrooms={props.feature.bathrooms ?? null}
                  halfBathrooms={props.feature.halfBathrooms ?? null}
                  bedrooms={props.feature.bedrooms ?? null}
                  floorLevel={props.feature.floorLevel ?? null}
                  floorsTotal={props.feature.floorsTotal ?? null}
                  sqmLand={props.feature.sqmLand ?? null}
                  sqmConstruction={props.feature.sqmConstruction ?? null}
                  pumps={props.feature.pumps ?? null}
                  parkingSpots={props.feature.parkingSpots ?? null}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
        py={0.5}
        wrap="nowrap"
      >
        {Boolean(props.status) && (
          <Grid item xs="auto">
            <MxCPropertyStatus title={props.status ?? ""} />
          </Grid>
        )}

        <Grid item xs="auto">
          <MxTypography
            variant="overline"
            color="grey.700"
            children={`${props.commissionGaranted}%`}
          />
        </Grid>

        <Grid item xs="auto">
          <MxCPropertyStans views={props.views} likes={props.likes} />
        </Grid>
      </Grid>
    </MxCPropertyContent>
  );
};

export default MxCardPropertySmall;
